import { ISetupData } from '@modeso/types__aumico-lib-annualreport-be';
import { IAccountingBasisDTO, ICurrencyDTO, ILegalFormDTO } from '@modeso/types__aumico-lib-settings-be';
import { ShareInformationDTO } from './shareInformation.dto';
export interface AnnualReportMetaInformationDTO {
    _id?: string;
    annualReportEncryptedId: string;
    companyName: string | null;
    balanceSheetDate: string | null;
    balancePreviousYearDate: string | null;
    currency: ICurrencyDTO | null;
    accountingBasis: IAccountingBasisDTO | null;
    legalForm: ILegalFormDTO | null;
    organizationId: string;
    archived: boolean;
    createdBy: string;
    createdAt?: Date;
    updatedBy: string;
    updatedAt?: Date;
    shareInformation: ShareInformationDTO | null;
    isPrintOnly: boolean;
    isSealed: boolean;
    locale: string;
    setupData?: ISetupData;
    integrations?: {
        bexio?: {
            isUsed?: boolean;
            lastSyncedAt?: Date | string | null;
        };
    };
}
